import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideMarkdown } from 'ngx-markdown';
import { ApplicationConfig, importProvidersFrom, provideAppInitializer, ErrorHandler, inject } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  Router,
  withDebugTracing,
  withEnabledBlockingInitialNavigation,
  withHashLocation,
  withInMemoryScrolling,
  withRouterConfig
  // withViewTransitions // Disabled to prevent ViewTransition conflicts
} from '@angular/router';
import { DropdownModule, SidebarModule } from '@coreui/angular';
import { IconSetService } from '@coreui/icons-angular';
//import * as Sentry from "@sentry/angular";
import { ApiModule, Configuration } from '../api';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';

// Enable router diagnostics - set to false in production
const ENABLE_ROUTER_DIAGNOSTICS = !environment.production;

import { environment } from '../environments/environment';
//import { TraceService } from '@sentry/angular';

export function apiConfigFactory(): Configuration {
  return new Configuration({
    basePath: environment.apiUrl
  });
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload'
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled'
      }),
      withEnabledBlockingInitialNavigation(),
      // withViewTransitions(), // Disabled to prevent ViewTransition conflicts
      withHashLocation(),
      // Enable Angular's built-in router tracing for detailed diagnostics
      ...(ENABLE_ROUTER_DIAGNOSTICS ? [withDebugTracing()] : [])
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideMarkdown(),
    importProvidersFrom(SidebarModule, DropdownModule, ApiModule.forRoot(apiConfigFactory)),
    IconSetService,
    // CoreUI components (c-alert, etc.) use Angular animations internally
    provideAnimationsAsync(),
    // {
    //   provide: ErrorHandler,
    //   useValue: Sentry.createErrorHandler()
    // },
    // {
    //   provide: Sentry.TraceService,
    //   deps: [Router]

    // },
    // provideAppInitializer(() => {
    //   inject(TraceService);
    // })
  ]
};
